import React from "react";
import { formatDate } from "../../../../../../utilities/formatDate";
import localeText from "../../../../../../locale";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { AdvancedImage } from "@cloudinary/react";
import { DataTable } from "primereact/datatable";
import { FilterMatchMode } from "primereact/api";
import { fill } from "@cloudinary/url-gen/actions/resize";
import { cloudinaryInstance } from "../../../../../../utilities/Cloudinary/cloudinaryInstance";
import { Dropdown } from "primereact/dropdown";
import { Calendar } from "primereact/calendar";
import { useHistory, useLocation } from "react-router-dom";

const OrdersTable = ({
  admin,
  orders,
  loading,
  sales,
  setCurrency,
  handleCurrency,
  setCurrentOrder,
  setOrderId_,
  setDisplayRateVisible,
}) => {
  const filters2 = {
    id: { value: null, matchMode: FilterMatchMode.CONTAINS },
    "buyer.username": { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    "seller.username": { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    status: { value: null, matchMode: FilterMatchMode.EQUALS },
    formatedDate: { value: null, matchMode: FilterMatchMode.EQUALS },
  };
  const history = useHistory();
  const url = useLocation();
  const urlToGo = url?.pathname?.includes("sales")
    ? "/dashboard-salesdetails?orderId="
    : "/dashboard-purchasesdetails?orderId=";

  return (
    <>
      {!admin ? (
        <DataTable
          value={orders}
          paginator
          responsiveLayout="scroll"
          loading={loading}
          filters={filters2}
          filterDisplay="row"
          paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
          currentPageReportTemplate={localeText("showingFirstToLast")}
          rows={10}
          rowsPerPageOptions={[10, 20, 50]}
        >
          <Column
            header={sales ? localeText("buyerProfilePic") : localeText("sellerProfilePic")}
            style={{ width: "10%" }}
            body={(order) => {
              return (
                <>
                  {sales ? (
                    <div
                      style={{
                        background: `url(${order.buyer.urlAvatar})`,
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                      }}
                      className="layout-dashboard-urlavatar"
                    ></div>
                  ) : (
                    <div
                      style={{
                        background: `url(${order.seller.urlAvatar})`,
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                      }}
                      className="layout-dashboard-urlavatar"
                    ></div>
                  )}
                </>
              );
            }}
          ></Column>
          <Column
            field="id"
            header={"ID"}
            style={{ width: "20%" }}
            filter
            filterPlaceholder={localeText("search")}
            filters={filters2}
            filterDisplay="row"
            sortable
          />
          <Column
            field={sales ? "buyer.username" : "seller.username"}
            style={{ width: "20%" }}
            header={sales ? localeText("byBuyer") : localeText("seller")}
            sortable
            filter
            filterPlaceholder={sales ? localeText("searchByBuyer") : localeText("searchBySeller")}
            filters={filters2}
            filterDisplay="row"
          />
          <Column
            header={localeText("preview")}
            body={(order) => {
              return (
                <div className="flex">
                  {order.itens
                    .filter((order, index) => index < 7)
                    .map((order) => {
                      return (
                        <div key={`p${order.id}`}>
                          <AdvancedImage
                            cldImg={cloudinaryInstance
                              .image(
                                order.productVariation
                                  ? order.productVariation.imageid
                                  : order.product.imageid1
                              )
                              .resize(fill().width(50).height(50))
                              .format("webp")}
                            style={{ outline: "1px solid #e0e0e0", outlineOffset: "4px" }}
                            className="border-round mr-3"
                            height={50}
                          />
                        </div>
                      );
                    })}
                </div>
              );
            }}
            style={{ width: "30%" }}
          />
          <Column
            field="itens.length"
            header={localeText("itemsQuantity")}
            style={{ width: "10%" }}
          />
          <Column
            header={localeText("orderDetails")}
            body={(order) => {
              return (
                <Button
                  icon="pi pi-eye"
                  onClick={() => {
                    const path = `${urlToGo}${order.id}`;
                    history.push(path);
                    /*  setCurrency(handleCurrency(order.itens[0].product.currency));
                    setCurrentOrder(order);*/
                  }}
                  className="p-button-help p-button-rounded"
                  style={{ textSize: "4em" }}
                />
              );
            }}
            style={{ width: "10%" }}
          />
          <Column
            header={localeText("status")}
            body={(order) => {
              return (
                <>
                  {order.status === "SENT" && (
                    <span
                      className="team-member-role text-0 p-1 border-round"
                      style={{ backgroundColor: "#42A5F5" }}
                    >
                      {localeText("sent").toUpperCase()}
                    </span>
                  )}
                  {order.status === "PAID" && (
                    <span
                      className="team-member-role text-0 p-1 border-round"
                      style={{ backgroundColor: "#F7B005" }}
                    >
                      {localeText("paid").toUpperCase()}
                    </span>
                  )}
                  {order.status === "RECEIVED" && (
                    <span
                      className="team-member-role text-0 p-1 border-round"
                      style={{ backgroundColor: "#46a748" }}
                    >
                      {localeText("received").toUpperCase()}
                    </span>
                  )}
                </>
              );
            }}
            sortable
            field="status"
          ></Column>
          <Column
            header={localeText("date")}
            body={(order) => {
              return <p>{formatDate(new Date(order.date))}</p>;
            }}
            sortable
            field="date"
          />
          <Column
            header={localeText("rating")}
            body={(order) => {
              return (
                <>
                  {order.status === "RECEIVED" && !order.evaluated && !sales && (
                    <Button
                      label={localeText("rate")}
                      icon="pi pi-star"
                      className="p-button-warning"
                      onClick={() => {
                        history.push(`/dashboard-purchases-evaluate?orderId=${order.id}`);
                      }}
                    />
                  )}
                </>
              );
            }}
          />
        </DataTable>
      ) : (
        <DataTable
          value={orders}
          paginator
          responsiveLayout="scroll"
          loading={loading}
          filters={filters2}
          filterDisplay="row"
          paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
          currentPageReportTemplate={localeText("showingFirstToLast")}
          rows={10}
          rowsPerPageOptions={[10, 20, 50]}
        >
          <Column
            header={localeText("buyerProfilePic")}
            style={{ width: "10%" }}
            body={(order) => {
              return (
                <>
                  <div
                    style={{
                      background: `url(${order.buyer.urlAvatar})`,
                      backgroundSize: "cover",
                      backgroundPosition: "center",
                    }}
                    className="layout-dashboard-urlavatar"
                  ></div>
                </>
              );
            }}
          />
          <Column
            header={localeText("sellerProfilePic")}
            style={{ width: "10%" }}
            body={(order) => {
              return (
                <>
                  <div
                    style={{
                      background: `url(${order.seller.urlAvatar})`,
                      backgroundSize: "cover",
                      backgroundPosition: "center",
                    }}
                    className="layout-dashboard-urlavatar"
                  ></div>
                </>
              );
            }}
          />
          <Column
            field="id"
            header={"ID"}
            style={{ width: "20%" }}
            filter
            filterPlaceholder={localeText("search")}
            filters={filters2}
            filterDisplay="row"
            sortable
          />
          <Column
            field="buyer.username"
            style={{ width: "20%" }}
            header={localeText("byBuyer")}
            sortable
            filter
            filterPlaceholder={localeText("searchByBuyer")}
            filters={filters2}
            filterDisplay="row"
          />
          <Column
            field="seller.username"
            style={{ width: "20%" }}
            header={localeText("seller")}
            sortable
            filter
            filterPlaceholder={localeText("searchBySeller")}
            filters={filters2}
            filterDisplay="row"
          />
          <Column
            header={localeText("preview")}
            body={(order) => {
              return (
                <div className="flex">
                  {order.itens
                    .filter((order, index) => index < 7)
                    .map((order) => {
                      return (
                        <div key={`p${order.id}`}>
                          <AdvancedImage
                            cldImg={cloudinaryInstance
                              .image(
                                order.productVariation
                                  ? order.productVariation.imageid
                                  : order.product.imageid1
                              )
                              .resize(fill().width(50).height(50))
                              .format("webp")}
                            style={{ outline: "1px solid #e0e0e0", outlineOffset: "4px" }}
                            className="border-round mr-3"
                            height={50}
                          />
                        </div>
                      );
                    })}
                </div>
              );
            }}
            style={{ width: "30%" }}
          />
          <Column
            field="itens.length"
            header={localeText("itemsQuantity")}
            style={{ width: "10%" }}
          />
          <Column
            header={localeText("orderDetails")}
            body={(order) => {
              return (
                <Button
                  icon="pi pi-eye"
                  onClick={() => {
                    const path = `${urlToGo}${order.id}`;
                    history.push(path);
                    // setCurrency(handleCurrency(order.itens[0].product.currency));
                    // setCurrentOrder(order);
                  }}
                  className="p-button-help p-button-rounded"
                  style={{ textSize: "4em" }}
                />
              );
            }}
            style={{ width: "10%" }}
          />
          <Column
            header={localeText("status")}
            style={{ minWidth: "150px" }}
            body={(order) => {
              return (
                <>
                  {order.status === "SENT" && (
                    <span
                      className="team-member-role text-0 p-1 border-round"
                      style={{ backgroundColor: "#42A5F5" }}
                    >
                      {localeText("sent").toUpperCase()}
                    </span>
                  )}
                  {order.status === "PAID" && (
                    <span
                      className="team-member-role text-0 p-1 border-round"
                      style={{ backgroundColor: "#F7B005" }}
                    >
                      {localeText("paid").toUpperCase()}
                    </span>
                  )}
                  {order.status === "PENDING" && (
                    <span
                      className="team-member-role text-0 p-1 border-round"
                      style={{ backgroundColor: "#F7B005" }}
                    >
                      {localeText("pending").toUpperCase()}
                    </span>
                  )}
                  {order.status === "RECEIVED" && (
                    <span
                      className="team-member-role text-0 p-1 border-round"
                      style={{ backgroundColor: "#46a748" }}
                    >
                      {localeText("received").toUpperCase()}
                    </span>
                  )}
                </>
              );
            }}
            filter
            showFilterMenu={false}
            filterElement={(option) => (
              <Dropdown
                value={option.value}
                options={[
                  { label: localeText("sent"), value: "SENT" },
                  { label: localeText("paid"), value: "PAID" },
                  { label: localeText("pending"), value: "PENDING" },
                  { label: localeText("received"), value: "RECEIVED" },
                ]}
                onChange={(e) => option.filterApplyCallback(e.value)}
                placeholder={localeText("status")}
              />
            )}
            filters={filters2}
            filterDisplay="row"
            sortable
            field="status"
          ></Column>
          <Column
            header={localeText("date")}
            body={(order) => {
              return <p>{order.formatedDate}</p>;
            }}
            field="formatedDate"
            style={{ minWidth: "180px" }}
            filters={filters2}
            showFilterMenu={false}
            filter
            filterElement={(option) => {
              return (
                <Calendar
                  value={option.value}
                  onChange={(e) => {
                    if (e.value !== null && e.value !== undefined) {
                      option.filterApplyCallback(formatDate(e.value));
                    }
                  }}
                  dateFormat="dd/mm/yy"
                />
              );
            }}
            sortable
            filterDisplay="row"
          />
        </DataTable>
      )}
    </>
  );
};

export default OrdersTable;
